import moment from 'moment';

export const formatDateAsString = (date, useMonthDayYear) => {
    if (!date) return '';

    return moment(date).format(useMonthDayYear ? 'MM-DD-YYYY' : 'DD-MM-YYYY');
};
